import { lazy } from 'react';
import PageView from './PageView';

const ChangeLogPage = lazy(() => import('src/pages/changeLog'));

export const changeLogRoutes = [
  {
    path: 'change-log',
    element: <PageView permission="BO_CAN_VIEW_CHANGE_LOGS" />,
    children: [{ element: <ChangeLogPage />, index: true }],
  },
];
